import apiClient from '../utils/apiClient';

/**
 * Shift Task API Services — Ad-hoc assignment & monitoring
 */
export const shiftTaskAPI = {
  /**
   * Giao task ad-hoc cho ca đang làm / đã duyệt (MANAGER|ADMIN)
   * @param {Object} data
   * @param {string} data.shift_id
   * @param {string} data.task_id
   * @param {number} [data.bonus_points_percentage] - 0-200
   * @param {string} [data.assignment_notes]
   */
  assignTaskToShift: async (data) => {
    return await apiClient.post({
      url: '/shift-tasks/assign',
      data,
    });
  },
};
